import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "al-shell" }
const _hoisted_2 = { class: "al-form-panel" }
const _hoisted_3 = { class: "al-form-wrap" }
const _hoisted_4 = { class: "al-field" }
const _hoisted_5 = { class: "al-input-wrap" }
const _hoisted_6 = { class: "al-field" }
const _hoisted_7 = { class: "al-input-wrap" }
const _hoisted_8 = ["type"]
const _hoisted_9 = {
  key: 0,
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_10 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_11 = {
  key: 0,
  class: "al-field"
}
const _hoisted_12 = { class: "al-input-wrap" }
const _hoisted_13 = {
  key: 1,
  class: "al-error",
  role: "alert"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "al-spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[17] || (_cache[17] = _createStaticVNode("<div class=\"al-brand\" data-v-310fc1d3><div class=\"al-brand-inner\" data-v-310fc1d3><div class=\"al-brand-logo\" data-v-310fc1d3><svg width=\"52\" height=\"52\" viewBox=\"0 0 48 48\" fill=\"none\" data-v-310fc1d3><rect width=\"48\" height=\"48\" rx=\"12\" fill=\"rgba(255,255,255,0.12)\" data-v-310fc1d3></rect><path d=\"M24 10L36 18V30L24 38L12 30V18L24 10Z\" fill=\"white\" fill-opacity=\"0.18\" stroke=\"white\" stroke-width=\"2\" data-v-310fc1d3></path><circle cx=\"24\" cy=\"24\" r=\"6\" fill=\"white\" data-v-310fc1d3></circle></svg><span class=\"al-brand-appname\" data-v-310fc1d3>Obra Tycoon</span></div><div class=\"al-brand-body\" data-v-310fc1d3><h2 class=\"al-brand-headline\" data-v-310fc1d3>Painel Administrativo</h2><p class=\"al-brand-tagline\" data-v-310fc1d3>Gestão centralizada de obras, usuários e recursos em um só lugar.</p><ul class=\"al-brand-features\" data-v-310fc1d3><li data-v-310fc1d3><svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-310fc1d3><polyline points=\"20 6 9 17 4 12\" data-v-310fc1d3></polyline></svg> Visão geral de todas as obras </li><li data-v-310fc1d3><svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-310fc1d3><polyline points=\"20 6 9 17 4 12\" data-v-310fc1d3></polyline></svg> Analytics de uso e armazenamento </li><li data-v-310fc1d3><svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-310fc1d3><polyline points=\"20 6 9 17 4 12\" data-v-310fc1d3></polyline></svg> Backup e importação de dados </li></ul></div><p class=\"al-brand-version\" data-v-310fc1d3>v0.6.0</p></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "al-form-header" }, [
          _createElementVNode("h1", { class: "al-form-title" }, "Entrar"),
          _createElementVNode("p", { class: "al-form-sub" }, "Use suas credenciais de administrador")
        ], -1)),
        _createElementVNode("form", {
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"])),
          class: "al-form",
          novalidate: ""
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[6] || (_cache[6] = _createElementVNode("label", {
              class: "al-label",
              for: "admin-username"
            }, "Usuário", -1)),
            _createElementVNode("div", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("svg", {
                class: "al-input-icon",
                width: "16",
                height: "16",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                _createElementVNode("circle", {
                  cx: "12",
                  cy: "7",
                  r: "4"
                })
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "admin-username",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
                type: "text",
                class: "al-input",
                placeholder: "admin",
                autocomplete: "username"
              }, null, 512), [
                [_vModelText, _ctx.username]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[10] || (_cache[10] = _createElementVNode("label", {
              class: "al-label",
              for: "admin-password"
            }, "Senha", -1)),
            _createElementVNode("div", _hoisted_7, [
              _cache[9] || (_cache[9] = _createElementVNode("svg", {
                class: "al-input-icon",
                width: "16",
                height: "16",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("rect", {
                  x: "3",
                  y: "11",
                  width: "18",
                  height: "11",
                  rx: "2",
                  ry: "2"
                }),
                _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "admin-password",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                type: _ctx.showPassword ? 'text' : 'password',
                class: "al-input",
                placeholder: "••••••",
                autocomplete: "current-password"
              }, null, 8, _hoisted_8), [
                [_vModelDynamic, _ctx.password]
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "al-eye-btn",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword)),
                tabindex: "-1",
                "aria-label": "Mostrar senha"
              }, [
                (!_ctx.showPassword)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1),
                      _createElementVNode("circle", {
                        cx: "12",
                        cy: "12",
                        r: "3"
                      }, null, -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_10, [...(_cache[8] || (_cache[8] = [
                      _createElementVNode("path", { d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" }, null, -1),
                      _createElementVNode("path", { d: "M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" }, null, -1),
                      _createElementVNode("line", {
                        x1: "1",
                        y1: "1",
                        x2: "23",
                        y2: "23"
                      }, null, -1)
                    ]))]))
              ])
            ])
          ]),
          (_ctx.twofaRequired)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _cache[12] || (_cache[12] = _createElementVNode("label", {
                  class: "al-label",
                  for: "admin-2fa"
                }, "Código de verificação (2FA)", -1)),
                _createElementVNode("div", _hoisted_12, [
                  _cache[11] || (_cache[11] = _createElementVNode("svg", {
                    class: "al-input-icon",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("rect", {
                      x: "3",
                      y: "11",
                      width: "18",
                      height: "11",
                      rx: "2"
                    }),
                    _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "admin-2fa",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.twofaToken) = $event)),
                    type: "text",
                    inputmode: "numeric",
                    class: "al-input",
                    placeholder: "000000 ou código de recuperação",
                    autocomplete: "one-time-code",
                    ref: "twofaInput"
                  }, null, 512), [
                    [_vModelText, _ctx.twofaToken]
                  ])
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("p", { class: "al-2fa-hint" }, "Abra seu app autenticador (celular ou PC) e digite o código de 6 dígitos. Sem o app? Use um código de recuperação.", -1))
              ]))
            : _createCommentVNode("", true),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _cache[14] || (_cache[14] = _createElementVNode("svg", {
                  width: "14",
                  height: "14",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("circle", {
                    cx: "12",
                    cy: "12",
                    r: "10"
                  }),
                  _createElementVNode("line", {
                    x1: "12",
                    y1: "8",
                    x2: "12",
                    y2: "12"
                  }),
                  _createElementVNode("line", {
                    x1: "12",
                    y1: "16",
                    x2: "12.01",
                    y2: "16"
                  })
                ], -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.error), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "submit",
            class: "al-btn",
            disabled: _ctx.loading
          }, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.loading ? 'Autenticando...' : (_ctx.twofaRequired ? 'Verificar e entrar' : 'Entrar')), 1)
          ], 8, _hoisted_14)
        ], 32),
        _cache[16] || (_cache[16] = _createElementVNode("p", { class: "al-security-note" }, [
          _createElementVNode("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" })
          ]),
          _createTextVNode(" Acesso restrito · Sessão criptografada ")
        ], -1))
      ])
    ])
  ]))
}